import config from './config.mjs';

/* globals __webpack_public_path__ */
__webpack_public_path__ = config.javaScriptDirectoryPath;
